"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _index = require("./index.styles");

var _excluded = ["LinkComponent", "name", "Icon"];

var MobileNavigationItem = function MobileNavigationItem(_ref) {
  var LinkComponent = _ref.LinkComponent,
      name = _ref.name,
      Icon = _ref.Icon,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  if (LinkComponent !== undefined) {
    otherProps.as = LinkComponent;
  }

  return /*#__PURE__*/_react["default"].createElement(_index.Link, otherProps, /*#__PURE__*/_react["default"].createElement(_index.Name, null, name), Icon ? /*#__PURE__*/_react["default"].createElement(Icon, null) : null);
};

MobileNavigationItem.propTypes = {
  LinkComponent: _propTypes.elementType,
  name: _propTypes.string.isRequired,
  Icon: _propTypes.elementType
};
var _default = MobileNavigationItem;
exports["default"] = _default;